<div class="groupme-chat-container">
  <div class="page-header">
    <h1>GroupMe Chats</h1>
  </div>

  <div *ngIf="checkingAuth" class="loading-indicator">
    <span class="fa fa-spinner fa-spin"></span>
    <span>Loading...</span>
  </div>

  <div *ngIf="!checkingAuth && !isAuthenticated" class="auth-section">
    <div class="auth-content">
      <span class="fa fa-lock auth-icon"></span>
      <h3>Connect to GroupMe</h3>
      <p>Connect your GroupMe account to view and send messages.</p>
      <button class="btn btn-ticomix btn-connect" (click)="authenticateGroupMe()">
        <span class="fa fa-link"></span> Connect GroupMe
      </button>
    </div>
  </div>

  <div *ngIf="!checkingAuth && isAuthenticated" class="row chat-container">
    <div class="col-md-3 groups-panel">
      <div class="groups-header">
        <h4>Groups</h4>
      </div>

      <div *ngIf="loadingGroups" class="loading-indicator">
        <span class="fa fa-spinner fa-spin"></span>
        <span>Loading groups...</span>
      </div>

      <div *ngIf="!loadingGroups" class="groups-list">
        <div *ngIf="groups.length === 0" class="no-groups">
          <span class="fa fa-users"></span>
          <p>No groups found</p>
        </div>

        <div *ngFor="let group of groups"
             class="group-item"
             [class.active]="selectedGroup?.GroupMeId === group.GroupMeId"
             (click)="selectGroup(group)">
          <div class="group-info">
            <div class="group-name">{{ group.Name }}</div>
            <div class="group-description" *ngIf="group.Description">{{ group.Description }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-9 messages-panel">
      <div *ngIf="!selectedGroup" class="no-selection">
        <span class="fa fa-comments-o"></span>
        <p>Select a group to view messages</p>
      </div>

      <div *ngIf="selectedGroup" class="messages-section">
        <div class="messages-header">
          <div class="header-content">
            <span class="fa fa-comments groupme-icon"></span>
            <h4>{{ selectedGroup.Name }}</h4>
          </div>
        </div>

        <div *ngIf="loadingMessages" class="loading-indicator">
          <span class="fa fa-spinner fa-spin"></span>
          <span>Loading messages...</span>
        </div>

        <div *ngIf="!loadingMessages" class="messages-content">
          <div class="messages-container" #messagesContainer>
            <div *ngIf="!messages?.Messages || messages?.Messages?.length === 0" class="no-messages">
              <span class="fa fa-comment-o"></span>
              <p>No messages yet</p>
            </div>

            <div *ngFor="let message of messages?.Messages" class="message">
              <div class="message-bubble">
                <div class="message-header">
                  <span class="message-author">{{ message.Name }}</span>
                  <span class="message-timestamp">{{ message.CreatedAt | date:'MMM d, h:mm a' }}</span>
                </div>
                <div class="message-content" *ngIf="message.Text">{{ message.Text }}</div>
                <div *ngIf="message.Attachments && message.Attachments.length > 0" class="message-attachments">
                  <ng-container *ngFor="let attachment of message.Attachments">
                    <div *ngIf="attachment.Type === 'image'" class="attachment-image-wrapper">
                      <img [src]="attachment.Url" class="attachment-image" />
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="send-message-section">
            <div *ngIf="selectedImageFile" class="image-preview">
              <div class="preview-content">
                <span class="fa fa-image preview-icon"></span>
                <span class="preview-filename">{{ selectedImageFile.name }}</span>
                <button class="btn-remove-preview" (click)="removeSelectedImage()" title="Remove image">
                  <span class="fa fa-times"></span>
                </button>
              </div>
            </div>

            <div class="message-input-wrapper">
              <input type="file"
                     #imageFileInput
                     style="display: none;"
                     accept=".png,.jpeg,.jpg,image/png,image/jpeg"
                     (change)="onImageSelected($event)" />
              <button class="btn-attach"
                      (click)="imageFileInput.click()"
                      [disabled]="sendingMessage"
                      title="Attach image">
                <span class="fa fa-paperclip"></span>
              </button>
              <div class="input-field">
                <textarea #messageInput
                          class="message-textarea"
                          [(ngModel)]="newMessageText"
                          placeholder="Type a message..."
                          [disabled]="sendingMessage"
                          rows="1"
                          wrap="soft"
                          (input)="autoResizeTextarea($event)"
                          (keydown)="onMessageKeyDown($event)"></textarea>
              </div>
              <button class="btn-send"
                      (click)="sendMessage()"
                      [disabled]="(!newMessageText.trim() && !selectedImageFile) || sendingMessage"
                      title="Send message">
                <span class="fa fa-paper-plane" *ngIf="!sendingMessage"></span>
                <span class="fa fa-spinner fa-spin" *ngIf="sendingMessage"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

